/* src/components/admin/AdminLayout.js */
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { useProfile } from '../../contexts/ProfileContext'; // To get user info if needed
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUserShield } from '@fortawesome/free-solid-svg-icons';

const AdminLayout = () => {
    const navigate = useNavigate();
    const { authUser } = useProfile(); // Get user if needed for display

    const handleLogout = async () => {
        try {
            await signOut(auth);
            console.log('[AdminLayout] Admin logged out.');
            navigate('/admin/login', { replace: true }); // Redirect to admin login after logout
        } catch (error) {
            console.error('[AdminLayout] Error logging out:', error);
            // Handle logout error (optional)
        }
    };

    return (
        <div className="flex flex-col min-h-screen bg-gray-100">
            {/* Admin Header */}
            <header className="bg-gray-800 text-white shadow-md">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        {/* Left Side - Title */}
                        <div className="flex items-center">
                             <FontAwesomeIcon icon={faUserShield} className="h-6 w-6 mr-3 text-indigo-400" />
                            <span className="text-xl font-semibold">Admin Panel</span>
                        </div>

                        {/* Right Side - User Info & Logout */}
                        <div className="flex items-center">
                            {authUser && (
                                <span className="text-sm text-gray-300 mr-4 hidden sm:inline">
                                    Logged in as: {authUser.email}
                                </span>
                            )}
                            <button
                                onClick={handleLogout}
                                className="flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-300 bg-gray-700 hover:bg-gray-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500 transition duration-150 ease-in-out"
                                aria-label="Logout"
                            >
                                <FontAwesomeIcon icon={faSignOutAlt} className="h-4 w-4 mr-2" />
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content Area */}
            <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Render the matched child route (e.g., AdminDashboard) */}
                <Outlet />
            </main>

             {/* Admin Footer */}
             <footer className="bg-gray-200 text-gray-600 text-center text-xs py-3 mt-auto">
                Dual N-Back Admin © {new Date().getFullYear()}
             </footer>
        </div>
    );
};

export default AdminLayout;